export default "__VITE_ASSET__4f018698__"